import { useEffect } from "react";
import { Contact } from "./Contact";
import { RegForm } from "./RegForm";
import { setDocumentTitle } from "../../utils";


const RegPage = () => {
    useEffect(() => {
        setDocumentTitle(`Записаться на просмотр - Официальный сайт Академия «Родина»`);
    }, [])
    return (
        <div className="max-w-[1024px] mx-auto p-2 pb-6">
            <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center text-slate-950">Запишись на просмотр!</h1>
            <div className="flex flex-col sm:flex-row w-full justify-center gap-2 sm:gap-6 pb-8">
                <Contact
                    name="Сорин Александр Михайлович"
                    title="Начальник селекционного отдела"
                    email="sorin@fcrodina.com"
                />
            </div>
            <RegForm />
        </div>

    );
}

export default RegPage;